import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {ActionLink, Panel} from 'components';
import Field from './Field';
import {FormattedMessage} from 'react-intl';
import EligibilityRecordModal from './EligibilityRecordModal';
import _ from 'lodash';

const EditEligibilityLink = observer(({uiState, record}) => {
  if (!record.isEligible) {
    return <FormattedMessage id={`benefit_enrolment.eligibility_record_states.${record.state}`}/>;
  }

  return (
    <ActionLink onClick={() => uiState.openEligibilityRecordModal(record)}>
      <FormattedMessage id={`benefit_enrolment.eligibility_record_states.${record.state}`} />
    </ActionLink>
  );
});

const EligibilityRecords = observer(({uiState}) => {
  const {eligibilityRecords} = uiState;
  if (_.isEmpty(eligibilityRecords)) return null;

  return (
    <Panel.Stack>
      <Panel>
        <Panel.Header
          title={t('benefit_enrolment.Additional Coverage Eligibility')}
          description={t('benefit_enrolment.ELIGIBILITY_RECORD_EXPLANATION')}/>
      </Panel>

      {eligibilityRecords.map(record => <Panel key={record.id}>
        <Panel.Subheader title={t(`models.coverage_types.${record.coverageType}`)} />
        <Field title='Current coverage amount' value={record.currentVolume}/>
        <Field title='Eligible coverage amount' value={record.eligibleVolume}/>
        <Field title='Eligibility status' value={<EditEligibilityLink uiState={uiState} record={record}/>}/>
      </Panel>)}
      <EligibilityRecordModal uiState={uiState} />
    </Panel.Stack>
  );
});

export default EligibilityRecords;
